export * from './help-anchor.directive';

import { HelpAnchorDirective } from './help-anchor.directive';

export const DIRECTIVES = [HelpAnchorDirective];
